import { render, staticRenderFns } from "./px-questionary-currency.vue?vue&type=template&id=1521b462&"
import script from "./px-questionary-currency.vue?vue&type=script&lang=ts&"
export * from "./px-questionary-currency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports